<template>
  <v-container>
    <v-row dense>
      <v-col>
        <CheckBox 
          :hint="$t('Внешние системы смогут управлять заказами доставки')"
          :label="$t('Разрешить подключения по API')"
          :original_value="config.integrations.enabled"
          v-model="local_config.integrations.enabled"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="7">
        <ListItemsController
          :disabled="!local_config.integrations.enabled"
          allow_create
          allow_delete

          :label="$t('Токены доступа API')"
          :original_value="config.integrations.access_token_list"
          v-model="local_config.integrations.access_token_list" 
        >

          <template #list-content="{ items, deleteItem }">
            <v-list-group v-for="(item, idx) in items" :key="idx" prepend-icon="mdi-pound">
              <template #activator>
                <v-list-item-title>{{item.name}}</v-list-item-title>
              </template>
              <v-text-field 
                class="mr-2 ml-16" 
                outlined 
                filled 
                hide-details 
                readonly 
                :value="item.token" 
                dense 
                @click:prepend-inner="copy" 
                @click:append-outer="deleteItem(idx)"
                prepend-inner-icon="mdi-content-copy"
                append-outer-icon="mdi-delete"
              >
              </v-text-field>
            </v-list-group>
          </template>
          <template #list-item>
          </template>
          <!-- <template #list-item="{ item, idx }">
            <v-list-item-avatar>
              <v-icon>mdi-pound</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.name }}
              </v-list-item-title>
              
              <v-list-item-subtitle v-if="idx === showing_id">
                
              </v-list-item-subtitle>
            </v-list-item-content>
          </template> -->

          <template #custom-interations="{idx}">
            <v-btn v-if="idx !== showing_id" icon @click="showing_id = idx"><v-icon>mdi-eye</v-icon></v-btn>
            <v-btn v-else icon @click="showing_id = undefined"><v-icon>mdi-eye-off</v-icon></v-btn>
          </template>

          <template #dialog="{item, submit}">
            <v-card>
              <v-card-title>
                <T>Добавление токена</T>
              </v-card-title>
              <v-form @submit.prevent="() => {item.token = uuid4(); submit()}">
                <v-card-text>
                  <TextField autofocus :label="$t('Название')" v-model="item.name"/>
                  <v-alert type="info" border="left" colored-border><T>Токен будет сгенерирован автоматически после ввода названия</T></v-alert>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn type="submit" text color="primary"><v-icon>mdi-content-save</v-icon>
                      <T key="1" >Добавить</T>
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </template>
        </ListItemsController>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import settings_group_mixin from '../settings_group_mixin'
import ListItemsController from '../../common/ListItemsController.vue'
import CheckBox from '../../common/CheckBox.vue'
import TextField from '../../common/TextField.vue'

export default {
  mixins: [settings_group_mixin],
  data: () => ({
    showing_id: undefined
  }),
  methods: {
    uuid4: () =>(
      String(1e7) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (
        Number(c) ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))
      ).toString(16)
    ),
    validate(){},
    copy(e){
      let input = e.target.closest('.v-input').getElementsByTagName('input')[0]
      input.select()
      input.setSelectionRange(0, 99999)

      document.execCommand('copy')
      this.$store.dispatch('throwTimeoutMessage', {
        message_data: this.$t('Токен скопирован в буфер обмена'),
        message_class: 'success'
      })
    }
  },
  components: {
    ListItemsController,
    CheckBox,
    TextField
  }
}
</script>